/* src/app/result/candidate-story/candidate-story.component.scss */
div.content-container {
}
div.text-container {
  text-align: left !important;
  left: 14%;
  position: absolute;
  width: 30%;
  top: 50%;
  transform: translate(0%, -50%);
  min-width: 517px;
}
div.fullScreen.video-container {
  position: static;
  width: auto;
}
div.video-container {
  text-align: left !important;
  left: 56%;
  z-index: 2;
  position: absolute;
  width: 30%;
  top: 50%;
  transform: translate(0%, -50%);
  min-width: 517px;
}
div.text-container p {
  margin: 20px 0 40px 0;
}
div.text-container a.active {
  margin-right: 16px;
}
video {
  height: 100%;
  width: 100%;
  z-index: 1;
  background: #262933 !important;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  object-fit: cover;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
}
.svg-bg {
  width: auto;
  height: auto;
  z-index: 2;
  background-size: contain;
  background-repeat: no-repeat;
  transition: 200ms;
  transition-timing-function: ease-in-out;
  -webkit-transition: 200ms;
  -webkit-transition-timing-function: ease-in-out;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}
.svg-bg.play {
  background-image: url(/assets/img/play.svg);
}
.svg-bg.play:hover {
  background-image: url(/assets/img/play-color.svg);
}
.svg-bg.pause {
  background-image: url(/assets/img/pause.svg);
}
.svg-bg.pause:hover {
  background-image: url(/assets/img/pause-color.svg);
}
.svg-bg.backward {
  background-image: url(/assets/img/backward.svg);
}
.svg-bg.backward:hover {
  background-image: url(/assets/img/backward-color.svg);
}
.svg-bg.forward {
  background-image: url(/assets/img/forward.svg);
}
.svg-bg.forward:hover {
  background-image: url(/assets/img/forward-color.svg);
}
.controls-group,
.time-group {
  float: left;
  margin-top: 29px;
  margin-bottom: 22px;
}
.controls-group {
  width: 70%;
}
.time-group {
  width: 30%;
}
.controls-group button.svg-bg {
  height: 24px;
  width: 24px;
  float: left;
  margin-right: 32px;
}
.time-group div {
  float: right;
}
.time-group .current,
.time-group .max,
.time-group .separator {
  font-family: "Campton-book";
  line-height: 1.33;
  letter-spacing: 1.8px;
  opacity: 0.5;
}
.time-group .current {
  opacity: 1;
  font-weight: bold;
}
.time-group .separator {
  line-height: 1;
  margin: 0 8px;
  font-size: 1.33rem;
}
.progress-group {
  bottom: 0;
  height: 4px;
  width: 100%;
  background-color: transparent;
  position: absolute;
}
.progress-group .played {
  width: 0%;
  opacity: 1;
  height: 4px;
  background-color: #ffffff;
  float: left;
}
.progress-group .unplayed {
  width: 100%;
  height: 4px;
  opacity: 0.4;
  background-color: #ffffff;
  float: left;
}
.progress-group .current {
  width: 4px;
  opacity: 1;
  height: 14px;
  background-color: #ffffff;
  float: left;
  position: absolute;
  left: 0%;
  top: -5px;
}
.video-wrapper {
  min-height: 300px;
  width: 100%;
  position: relative;
  min-width: 482px;
  background: #262933 !important;
}
@media (max-width: 80em) {
  div.text-container {
    left: 4%;
    width: 40%;
    min-width: 542px;
  }
  div.video-container {
    left: 55%;
    width: 40%;
    min-width: 482px;
  }
}
.fullScreen .videobg {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #262933 !important;
}
.fullScreen .videobg-width {
  position: absolute;
  width: 100%;
  height: 100%;
  left: -9999px;
  right: -9999px;
  top: 0;
  margin: auto;
  background: #262933 !important;
}
.fullScreen .videobg-aspect {
  position: absolute;
  width: 100%;
  height: 0;
  top: -9999px;
  bottom: -9999px;
  margin: auto;
  padding-bottom: 56.25%;
  overflow: hidden;
  background: #262933 !important;
}
.fullScreen .videobg-make-height {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #262933 !important;
}
.fullScreen .videobg-hide-controls {
  box-sizing: content-box;
  position: relative;
  height: 102%;
  width: 102%;
  padding: 60px 89.7777px;
  top: -55px;
  left: -97.7777px;
  background: #262933 !important;
}
.fullScreen .videobg iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: 0 none;
  background: #262933 !important;
}
.fullScreen .absolute-divs.controls-container .progress-group {
  width: 98%;
}
.fullScreen .absolute-divs.controls-container {
  position: absolute;
  bottom: 80px;
  width: 100%;
  z-index: 101;
  padding: 15px;
}
.svg-bg.onsubtitles {
  background-image: url(/assets/img/subtitles-on.svg);
  filter: invert(1);
}
.svg-bg.offsubtitles {
  background-image: url(/assets/img/subtitles-off.svg);
  filter: invert(1);
}
.grad {
  background-image:
    linear-gradient(
      46deg,
      #1f1f24,
      rgba(0, 0, 0, 0.5) 65%,
      rgba(0, 0, 0, 0));
}
.hide {
  display: none;
}
.play-next-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.play-next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/*# sourceMappingURL=candidate-story.component.css.map */
